/**
 * Constants for client-side metrics used in RUM and CloudWatch publishing
 */
export enum ClientSideMetricsConstants {
    LATENCY = 'Latency',
    FATAL = 'FATAL',
    FATAL_RIV = 'FATAL.RIV',
    FATAL_RIV_USER_EXCEPTION = 'FATAL.RIV.UserException',
}
